import React from 'react';
import { ReactSVG } from "react-svg";
import i18n from "../../i18n/i18n.js";
import TypedLink from '../TypedLink/TypedLink.js';
import './ProductCartItem.css';
import { ModalsContext, withAppContext } from '../../contexts/AppContext.js';
import BottomSheetSelect from '../BottomSheetSelect/BottomSheetSelect.js';
import { th } from 'framer-motion/client';


class ProductCartItem extends React.Component {

  max_quantity = 100;

  static contextType = ModalsContext;

  constructor(props) {
    super(props);

    this.state = {
      product: props.product ? props.product : {},
      operationsOpen: false
    };

    this.is_my_orders = props.is_my_orders ? props.is_my_orders : false;
    this.select_quantity = props.select_quantity ? props.select_quantity : false;
    this.on_change_product = props.on_change_product ? props.on_change_product : () => {};
    this.is_checkout = props.isCheckout ? props.isCheckout : false;

    if(this.is_checkout){
      this.select_quantity = false;
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.product !== this.props.product) {
      this.setState({ product: this.props.product });
    }
  }

  handle_quantity_change(event) {

    event.preventDefault();

    const product = {...this.state.product};
    product.pc = parseInt(event.target.value);

    
    this.on_change_product(product,event);
    
  }

  handle_stepper_change(newValue, event) {
    event.preventDefault();
    if (newValue < 1) return; // Allow 0 to remove


    if (newValue > this.max_quantity) {
      newValue = this.max_quantity;
    }

    const product = {...this.state.product};
    product.pc = newValue;
    
    this.on_change_product(product, event);
  }

  render_image(product)
  {
    if(product?.product_image[0]?.thumb_small_?.filename)
    {
      return <img src={process.env.REACT_APP_ORIGINAL_SHOP_URL+'/'+product.product_image[0].thumb_small_.filename}/>
    }
  }

  on_product_click(e) {
    this.context.AppFooterMenuRef.current.hide_all_menu_item();
  }

  render_gift_labels(product)
  {
    const labels = [];

    if(parseInt(product?.discount_group_gift_id) > 0){
      labels.push(i18n.t('cartGiftProductLabel'));
    }
    if(parseInt(product?.cumulative_giftpack_id) > 0 && product?.cumulative_giftpack_label){
      labels.push(product.cumulative_giftpack_label);
    }

    if(!labels.length){
      return null;
    }

    return <div className="gift_labels">
      {labels.map((label, index) => <span key={index} className="gift_product_label">{label}</span>)}
    </div>;
  }

  render() {

    const product = this.state.product;

    if (!!product.id)
    {
      
      const is_favorite = this.props.appContext.appRef.current.is_favorite_product(product);
      const fav_option = (!is_favorite) ? {label: i18n.t('favoriteAddToFavorites'), value: 'favorite_add'} : {label: i18n.t('favoriteRemoveFromFavorites'), value: 'favorite_remove'};

      return ( 
        <div key={product.id} className="product_cart_item"> 

          {(!this.is_my_orders && !this.is_checkout) ? <button className='select-operation' onClick={() => this.setState({operationsOpen: true})}>...</button> : ''}
          
          {!this.is_checkout ?
          <BottomSheetSelect
              isOpen={this.state.operationsOpen}
              onClose={() => this.setState({operationsOpen: false})}
              options={[{label: i18n.t('deleteCartItem'), value: 'delete', style:{color: 'red'}},fav_option]}
              onChange={(value) => {
                const product = {...this.state.product};
                const event = value.target.value;
                this.on_change_product(product,event);
                this.setState({operationsOpen: false});
              }}
              selectedValue={()=>{}}
              title={i18n.t('minicartItemActionsTitle')}
          />
          : ''}

          <div className="product_image">
          {product.url.length && parseInt(product.active) ? <TypedLink onClick={(e)=> this.on_product_click(e)} link={{type: 'product', url: product.url}}>
              {this.render_image(product)}
            </TypedLink> : this.render_image(product)}
          </div>

          <div className="product_data">
            {this.render_gift_labels(product)}
            <div className="name">{product.url.length && parseInt(product.active) ? <TypedLink onClick={(e)=>{this.on_product_click(e)}} link={{type: 'product', url: product.url}}><b>{product.product}</b></TypedLink> : <b>{product.product}</b>}</div>
              
            <div className="price">
              {/*<label>{i18n.t('shoppingCartGrossPrice')}:</label>*/}
              <p>
                <b className={parseInt(product?.sale)>0 ? "sale" : ''}>{product.price_gross}</b>
                {parseInt(product?.sale)>0 ? <b className='stroked'>{product.price_original_gross}</b> : ''}
              </p>
            </div>

            {product.item_attributes ? 
            <div className="attributes">
               <p>{product.item_attributes}</p>
            </div>
            : ''}
            
            <div className="quantity">
              {/*<label>{i18n.t('shoppingCartQuantity')}:</label>*/}
              {!!this.select_quantity ? 
                <div className="quantity-stepper">
                  <button className="stepper-btn" type="button" onClick={(e) => this.handle_stepper_change(parseInt(product.pc) - 1, e)}>−</button>
                  <span className="stepper-value">{product.pc}</span>
                  <button className="stepper-btn" type="button" onClick={(e) => this.handle_stepper_change(parseInt(product.pc) + 1, e)}>+</button>
                </div>
              : <p className='quantity-label-only'>{i18n.t('minicartQuantity', { count: product.pc })}</p>}
            </div>

          </div>

        </div>
      );
    }
    else {
      return '';
    }
  }
};

export default withAppContext(ProductCartItem);

